export default __webpack_public_path__ + "static/media/draft.41e125d1.webp";